"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STARRED_MESSAGE = void 0;
exports.STARRED_MESSAGE = "STARRED_MESSAGE";
